import type {
  CompanyListItemFragment,
  GameConsoleListItemFragment,
  GameListItemFragment,
  GameSeriesListItemFragment,
  MediaBatchEditItemFragment,
  TagListItemFragment
} from "../../graphql/types"

export type ArrayMode = "noop" | "add" | "remove" | "replace"

export type ScalarField =
  | "copyright"
  | "copyrightUrl"
  | "license"
  | "licenseUrl"
  | "sourceUrl"

export type ArrayField =
  | "tags"
  | "companies"
  | "gameSeries"
  | "games"
  | "gameConsoles"

export interface EntityRef {
  uuid: string
}

export interface BatchEditItem {
  uuid: string
  filename: string
  mediaType: string | null | undefined
  length: number
  previewUrl: string | null | undefined

  copyright: string
  copyrightUrl: string
  license: string
  licenseUrl: string
  sourceUrl: string
  watermark: boolean

  tags: TagListItemFragment[]
  companies: CompanyListItemFragment[]
  gameSeries: GameSeriesListItemFragment[]
  games: GameListItemFragment[]
  gameConsoles: GameConsoleListItemFragment[]
}

export function computePerItemArray<T extends EntityRef>(
  mode: ArrayMode,
  current: T[],
  patch: T[]
): T[] {
  switch (mode) {
    case "noop":
      return current
    case "add": {
      const seen = new Set(current.map(c => c.uuid))
      const result = [...current]
      for (const p of patch) {
        if (!seen.has(p.uuid)) {
          seen.add(p.uuid)
          result.push(p)
        }
      }
      return result
    }
    case "remove": {
      const remove = new Set(patch.map(p => p.uuid))
      return current.filter(c => !remove.has(c.uuid))
    }
    case "replace":
      return patch
  }
}

export function fromBatchEditItemFragment(
  fragment: MediaBatchEditItemFragment
): BatchEditItem {
  return {
    uuid: fragment.uuid,
    filename: fragment.filename,
    mediaType: fragment.mediaType,
    length: fragment.length,
    previewUrl: fragment.previewUrl110 ?? fragment.previewUrl140 ?? null,
    copyright: fragment.copyright ?? "",
    copyrightUrl: fragment.copyrightUrl ?? "",
    license: fragment.license ?? "",
    licenseUrl: fragment.licenseUrl ?? "",
    sourceUrl: fragment.sourceUrl ?? "",
    watermark: fragment.watermark,
    tags: fragment.tags ?? [],
    companies: fragment.companies ?? [],
    gameSeries: fragment.gameSeries ?? [],
    games: fragment.games ?? [],
    gameConsoles: fragment.gameConsoles ?? []
  }
}
